import { render, staticRenderFns } from "./MarketingTaskEditor.vue?vue&type=template&id=8728552c&scoped=true"
import script from "./MarketingTaskEditor.vue?vue&type=script&lang=js"
export * from "./MarketingTaskEditor.vue?vue&type=script&lang=js"
import style0 from "./MarketingTaskEditor.vue?vue&type=style&index=0&id=8728552c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8728552c",
  null
  
)

export default component.exports